'use client';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSiteConfig } from '../../../../siteConfig';
import { HotelUtility } from '../../hotel/hotel_title';
import UtilityButton from '../../buttons/utilityButton';
import BgMedia from '../backgrounds/bg_media';
import SkiliftIcon from '../../atoms/icons/skilift';
import SkibusIcon from '../../atoms/icons/skibus';
import TownCentreIcon from '../../atoms/icons/towncentre';
import STSHotelIcon from '../../atoms/icons/sts_hotel';
import CalendarIcon from '../../atoms/icons/calendar';
import FlightIcon from '../../atoms/icons/flight';
//import HotelRoomIcon from '../../atoms/icons/hotelroom';
import CheckmarkIcon from '../../atoms/icons/checkmark';
import { trackFeedItemSelect } from './feedUtility';
import { getDateString } from '../../../utils/dateTime';
import { v4 as uuidv4 } from 'uuid';
import TrainIcon from '../../atoms/icons/train';

const ProposalCard = ({
  proposal: initProposal,
  charterTypeId,
  layout,
  rooms,
  keyId,
  offerCode,
  hasChildren = false,
  isModal,
  setModalProposal,
}) => {
  const { t } = useTranslation(['booking']);

  const { ethelBookingURL, locale } = getSiteConfig();

  const {
    hotel,
    perPersonPrice = null,
    price = null,
    destination,
    flightCharter,
    ordinaryPerPersonPrice,
    ordinaryPrice,
    transportationType,
    alternativeProposals = [],
  } = initProposal;

  const [proposal, setProposal] = useState(initProposal);

  const roomProposals = proposal.hotel?.roomProposals;

  /* const uniqueRooms = roomProposals
    ?.flatMap((rp) => rp.rooms)
    .reduce((acc, room) => {
      if (!acc[room.description]) {
        acc[room.description] = 1;
      } else {
        acc[room.description]++;
      }
      return acc;
    }, []); */

  const airlineImageId =
    flightCharter?.outwardFlights[0].airline === 'AY' ? '21394' : '15980';
  const imageId = hotel
    ? hotel.info?.imageUrls[0]?.match(/\d{3,5}/)
    : airlineImageId;

  //finnair 21394

  const mediaParams = {
    backgroundMedia: {
      filename: hotel
        ? hotel?.info.imageUrls && hotel.info.imageUrls.length > 0
          ? hotel?.info.imageUrls[0]
          : ''
        : '15980',
      alt: hotel?.info.name,
      zIndex: 'z-0',
      parentWidth: 'w-1/2',
    },
    imageId: imageId,
  };

  const familyPriceLabel = hotel
    ? hasChildren
      ? 'FamilyPrice'
      : 'TotalPrice'
    : 'FlightPrice';

  const label =
    perPersonPrice !== null ? (
      <span>
        {t('PerPersonPrice', {
          price: Math.floor(perPersonPrice).toLocaleString(locale),
        })}{' '}
      </span>
    ) : (
      <span>
        {t(familyPriceLabel, {
          price: price.toLocaleString(locale),
        })}{' '}
      </span>
    );

  const stsHotels = [
    'SALZ',
    'EDEN',
    'GOET',
    'REIN',
    'POST',
    'GISE',
    'ORAN',
    'MARM',
    'BREIT',
    'EDAP',
  ];
  const sts_hotel = stsHotels.includes(hotel?.hotelId);

  const createCharter = async (reservationId, selectedProposal) => {
    const { hotel, flightCharter } = selectedProposal;

    let charterObject = {
      destinationId: destination.id,
      salesChannelId: 'Web',
      charterTypeId: charterTypeId,
      homewardDate: flightCharter ? flightCharter.home : hotel.checkoutDate,
      outwardDate: flightCharter ? flightCharter.out : hotel.checkinDate,
      reservationId: reservationId,
    };

    if (hotel) {
      charterObject = {
        ...charterObject,
        ...{
          rooms: hotel.roomProposals
            .flatMap((rp) => rp.rooms)
            .map((room) => ({
              travelers: room.beds.map((traveler) => ({
                id: traveler.travelerId,
                age: traveler.travelerAge,
                birthdate: null,
                isInfant: traveler.travelerAge < 2,
              })),
            })),
        },
      };
    }

    if (flightCharter) {
      charterObject = {
        ...charterObject,
        ...{
          airportId: flightCharter?.outwardFlights[0].originAirportId,
        },
      };

      if (!hotel) {
        charterObject = {
          ...charterObject,
          ...{
            flightTravelers: rooms?.flatMap((rp) => rp.travelers),
          },
        };
      }
    }
    return fetch(`${ethelBookingURL}/api/v1/command/createCharter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(charterObject),
    });
  };

  const selectProposal = async (reservationId, selectedProposal) => {
    let proposalObject = {
      packageId: selectedProposal.package.id,
      reservationId: reservationId,
    };

    const { hotel, flightCharter } = selectedProposal;

    if (hotel) {
      proposalObject.hotel = {
        charterPeriodId: hotel.charterPeriodId,
        rooms: hotel.roomProposals
          .flatMap((rp) => rp.rooms)
          .map((room) => ({ id: room.id, travelerIds: room.travelerIds })),
      };
    }

    if (flightCharter) {
      if (!hotel) {
        proposalObject.flightCharter = {
          id: flightCharter.id,
          travelerIds: rooms?.flatMap((rp) => rp.travelers).map((r) => r.id),
        };
        //proposalObject.flightTravelers = rooms?.flatMap((rp) => rp.travelers);
      } else {
        proposalObject.flightCharterId = flightCharter.id;
      }
    }

    return fetch(
      `${ethelBookingURL}/api/v1/command/travelBooking/selectProposal`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(proposalObject),
      },
    );
  };

  const setOfferCode = async (reservationId) => {
    if (offerCode && offerCode !== '') {
      return fetch(
        `${ethelBookingURL}/api/v1/command/travelBooking/setOfferCode`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            reservationId: reservationId,
            offerCode: offerCode,
          }),
        },
      );
    }
  };

  const navigateToBooking = async (selectedProposal) => {
    const reservationId = uuidv4();

    await createCharter(reservationId, selectedProposal);
    await setOfferCode(reservationId);
    await selectProposal(reservationId, selectedProposal);
    trackFeedItemSelect({
      ...selectedProposal,
      period: {
        out:
          selectedProposal?.flightCharter?.out ||
          selectedProposal?.hotel?.checkinDate,
        home:
          selectedProposal?.flightCharter?.home ||
          selectedProposal?.hotel?.checkoutDate,
      },
    });

    if (selectedProposal?.hotel) {
      window.location.href = `${ethelBookingURL}/room-proposal/${reservationId}`;
    } else {
      window.location.href = `${ethelBookingURL}/travelers/${reservationId}`;
    }
  };

  const [cardLayout, setCardLayout] = useState(layout);
  /* 
  useEffect(() => {
    if (isModal) {
      setCardLayout('list');
    } else {
      setCardLayout(layout);
    }
  }, [isModal, layout]);
 */
  const handleClick = (e) => {
    /* TODO: enable for search 2.0 */
    if (alternativeProposals.length > 0 && !isModal) {
      //show modal with alternative packages
      setModalProposal({
        proposal: proposal,
        charterTypeId: charterTypeId,
        layout: 'grid',
        rooms: rooms,
        offerCode: offerCode,
        hasChildren: false,
        isModal: true,
        setModalProposal: setModalProposal,
      });
    } else {
      navigateToBooking(proposal);
    }
  };

  return (
    <section
      key={keyId}
      className={`${
        isModal ? 'drop-shadow-2xl z-110 w-full max-w-screen-xs mx-auto' : ''
      } col-span-12 ${
        cardLayout === 'list' || isModal
          ? 'md:col-span-12'
          : 'md:col-span-6 lg:col-span-4'
      } grid grid-cols-12 grid-rows-contentBlock  mt-4 h-auto bg-yellow-15 rounded`}
    >
      <div
        className={`${
          cardLayout === 'list'
            ? 'col-span-12 md:col-span-6 ' + (isModal ? '' : 'lg:col-span-4')
            : 'col-span-12'
        }`}
      >
        <div className="flex flex-col justify-start">
          <div className="px-0 w-full aspect-4/3 relative">
            <BgMedia mediaParams={mediaParams} />
            {(perPersonPrice < ordinaryPerPersonPrice ||
              price < ordinaryPrice) && (
              <div className="absolute top-0 left-0 flex bg-orange p-2 text-white rounded m-2">
                <span className="relative text-xs lg:text-sm font-crystalCondensed">
                  {t('Savings', {
                    price: (ordinaryPrice - price).toLocaleString(locale),
                  })}
                </span>
              </div>
            )}

            {proposal.package.imageUrl && (
              <div className="absolute top-0 right-0 flex m-2">
                <div className="w-16">
                  <img src={proposal.package.imageUrl} alt="package" />
                </div>
              </div>
            )}
            {!proposal.package.imageUrl && sts_hotel && (
              <div className="absolute top-0 right-0 flex m-2">
                <div className="w-16">
                  <STSHotelIcon />
                </div>
              </div>
            )}
            {hotel && (
              <div className="absolute bottom-0 flex bg-white rounded-lg m-2">
                <div
                  className={`flex items-center flex-nowrap bg-white rounded-l-lg pl-2 mr-[1px]`}
                >
                  <div
                    className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}
                  >
                    <SkiliftIcon />
                  </div>
                  <span className="text-xs pr-2">
                    {hotel.info.distanceToLift} m
                  </span>
                </div>
                <div
                  className={`flex items-center flex-nowrap bg-white pl-2 mr-[1px]`}
                >
                  <div
                    className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}
                  >
                    <SkibusIcon />
                  </div>
                  <span className="text-xs pr-2">
                    {hotel.info.distanceToSkibus} m
                  </span>
                </div>
                <div
                  className={`flex items-center flex-nowrap bg-white rounded-r-lg pl-2`}
                >
                  <div
                    className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}
                  >
                    <TownCentreIcon />
                  </div>
                  <span className="text-xxs pr-2">
                    {hotel.info.distanceToTownCentre} m
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={`${
          cardLayout === 'grid'
            ? 'col-span-12'
            : 'col-span-12 md:col-span-6 ' +
              (isModal ? 'lg:col-span-6' : 'lg:col-span-8')
        } grid-cols-12 flex flex-col justify-between`}
      >
        <div className="col-span-12">
          <div className={`${cardLayout === 'grid ' ? 'py-0' : 'py-4'} px-4`}>
            {hotel && (
              <>
                <HotelUtility
                  hotel={{ name: hotel.info.name, stars: hotel.info.stars }}
                  textStyle="base"
                />
                <h2 className="text-base">{destination.description}</h2>
                {/*                 <div className="grid grid-cols-iconText gap-2">
                  <div className="w-8 h-6 mr-0 flex flex-wrap items-center">
                    <HotelRoomIcon />
                  </div>
                  <div>
                    <span className="text-sm">
                      {Object.entries(uniqueRooms).map(
                        ([description, count], index) => (
                          <>
                            {count} x {description}
                            {index < Object.entries(uniqueRooms).length - 1 ? (
                              <span key={index}>,&nbsp;</span>
                            ) : (
                              ''
                            )}
                          </>
                        ),
                      )}
                    </span>
                  </div>
                </div>
 */}{' '}
              </>
            )}
            {flightCharter && !hotel && (
              <h2 className="text-base">{destination.description}</h2>
            )}
            {flightCharter && (
              <>
                <div className="grid grid-cols-iconText gap-2">
                  <div className="w-8 h-6 mr-0 flex flex-wrap items-center">
                    {transportationType === 'Bus' ? (
                      <TrainIcon />
                    ) : (
                      <FlightIcon />
                    )}
                  </div>
                  <div>
                    <span className="text-sm">
                      {flightCharter?.outwardFlights?.map((fh, index) => (
                        <>
                          {index === 0
                            ? ` ${fh.originAirport} <> ${fh.destinationAirport} `
                            : ` <> ${fh.destinationAirport} `}
                        </>
                      ))}
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-iconText gap-2">
                  <div className="w-8 h-6 mr-0 flex flex-wrap items-center">
                    <CalendarIcon />
                  </div>
                  <div>
                    <span className="text-sm">
                      {getDateString(
                        flightCharter.out,
                        flightCharter.homewardFlights.at(-1).arrivalDateTime,
                        true,
                      )}
                    </span>
                  </div>
                </div>
              </>
            )}
            {!flightCharter && hotel && (
              <div className="grid grid-cols-iconText gap-2">
                <div className="w-8 h-6 mr-0 flex flex-wrap items-center">
                  <CalendarIcon />
                </div>
                <div>
                  <span className="text-sm">
                    {getDateString(hotel.checkinDate, hotel.checkoutDate)}
                  </span>
                </div>
              </div>
            )}
            <div className="grid grid-cols-iconText gap-2">
              <div className="w-8 h-6 mr-0 flex flex-wrap items-center">
                <CheckmarkIcon />
              </div>
              <div>
                <span className="text-sm">
                  {proposal.package.description} - {proposal.package.shortInfo}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 rounded-b md:rounded-r">
          <div className="px-4 pt-4">
            <div className="-mx-1">
              <UtilityButton
                label={label}
                onClick={() => {
                  setProposal(initProposal);
                  handleClick();
                }}
                width="w-max"
                color={
                  perPersonPrice < ordinaryPerPersonPrice ||
                  price < ordinaryPrice
                    ? 'button-orange-announcement'
                    : 'yellow'
                }
              />
            </div>

            {isModal &&
              alternativeProposals.map((p, i) => (
                <a
                  className="text-sm pb-4 pl-3"
                  onClick={() => navigateToBooking(p)}
                  href="#"
                >
                  {p.package?.description} - {p.package?.shortInfo}
                </a>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProposalCard;
